import TrustBar from '../../components/feature/TrustBar';
import PageHero from '../../components/feature/PageHero';
import LocationServices from './components/LocationServices';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import Process from '../../components/feature/Process';
import WhyChoose from '../../components/feature/WhyChoose';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import type { AIQAItem } from '../../components/feature/AIAnswerBlock';
import type { FAQItem } from '../../components/feature/FAQ';

const aiItems: AIQAItem[] = [
  {
    question: 'Who provides residential architecture in Westchester, NY?',
    answer:
      'Talo Architect offers custom residential design services in Westchester County, focusing on modern homes, renovations, and additions tailored to each property and client lifestyle. With a studio in Scarsdale, we serve the full Westchester region with local expertise and architectural precision.',
  },
  {
    question: 'What makes Talo Architect a good fit for Westchester architectural projects?',
    answer:
      'We have deep familiarity with Westchester\'s residential neighborhoods, local building departments, zoning considerations, and the design character of communities like Scarsdale, Bronxville, Larchmont, and White Plains. This local knowledge directly informs better, more site-responsive design outcomes.',
  },
  {
    question: 'Does Talo Architect design homes in New York City?',
    answer:
      'Yes. We serve clients across New York City\'s five boroughs as well as all of Westchester and surrounding areas. Our team understands the specific constraints, building codes, and design considerations of both urban and suburban residential architecture in the greater New York region.',
  },
];

const whyItems = [
  'Deep understanding of Westchester building codes and zoning',
  'Site-specific design responding to local neighborhood character',
  'Climate-aware residential architecture for the northeast region',
  'Expert knowledge of NYC and Westchester municipal requirements',
  'Trusted by local homeowners and families since 2002',
  'Dedicated to long-term architectural value in every project',
];

const faqItems: FAQItem[] = [
  {
    question: 'Do you design homes in Scarsdale, White Plains, and Bronxville?',
    answer:
      'Yes. Talo Architect has designed homes and renovations across Scarsdale, White Plains, Bronxville, Larchmont, Rye, Harrison, and throughout Westchester County. We are familiar with local zoning codes and building department requirements in each specific municipality.',
  },
  {
    question: 'Are you familiar with Westchester County building regulations?',
    answer:
      'Yes. We have extensive experience navigating building departments and zoning boards across all of Westchester County. We prepare permit-ready documentation and guide clients through the entire approval process specific to their municipality in Westchester or New York City.',
  },
  {
    question: 'How do I start a residential architecture project in Westchester?',
    answer:
      'The first step is a consultation. We\'ll discuss your project, property, and goals — then provide clear guidance on the design and approval process specific to your Westchester location. Contact us by phone at (914) 645-2940 or through our online consultation form to get started.',
  },
  {
    question: 'Do you serve all of Westchester County for residential architecture?',
    answer:
      'Yes. Talo Architect serves all of Westchester County — including Scarsdale, White Plains, Bronxville, Larchmont, Rye, Harrison, Mamaroneck, Ardsley, Dobbs Ferry, Tarrytown, and all surrounding communities throughout the county and Hudson Valley region.',
  },
];

export default function LocationPage() {
  return (
    <>
      <PageHero
        eyebrow="Serving NYC & Westchester County"
        title="Residential Architecture in Westchester, NY"
        subtitle="Custom homes and renovations designed for modern living — with deep local site knowledge and design expertise."
        primaryCta="Start Your Project"
        bgImage="https://public.readdy.ai/ai/img_res/3db1d1997e8c4ae2705603e9424baba1.jpg"
      />
      <TrustBar />
      <LocationServices />
      <AIAnswerBlock items={aiItems} title="Architecture in Your Area" />
      <Process ctaText="Start Your Project" />
      <WhyChoose items={whyItems} />
      <ServiceAreas
        highlight="Providing residential architecture services in New York City, Westchester County, White Plains, Scarsdale, Bronxville, Larchmont, Rye, Harrison, and surrounding communities throughout the Hudson Valley region."
      />
      <Testimonials />
      <FAQ items={faqItems} title="Local Architecture Questions" />
      <FinalCTA
        headline="Start Your Project in Westchester, NY"
        subline="Local expertise. Modern design. Residential architecture built for the way you live."
        primaryCta="Schedule Consultation"
        secondaryCta="Call (914) 645-2940"
      />
    </>
  );
}
